import {
  IManageContextState,
  useManageContext,
} from './contexts/ManageContext/ManageContext';
import { useCallback, useEffect, useRef } from 'react';

export const useAppState = (): IManageContextState => {
  const { state } = useManageContext();
  return state;
};

export const useAppDispatch = (): ((name: string, args: any) => void) => {
  const { dispatch } = useManageContext();

  return useCallback(
    (name: string, args: any) => {
      dispatch({ type: name, data: args });
    },
    [dispatch]
  );
};

export const usePrevious = (value: any) => {
  const ref = useRef();

  useEffect(() => {
    ref.current = value;
  });

  return ref.current;
};
